import React from 'react';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'design-system/Modal';
// eslint-disable-next-line restrict-imports/restrict-imports
import theme from 'design-system/product/theme';
import NucleusButton from 'react-scale/nucleus/components/NucleusButton';

interface ConfirmationModalProps {
  isOpen: boolean;
  canSubmit?: boolean;
  message: React.ReactNode;
  onSubmit: () => void;
  onRequestClose: () => void;
  marginAmount?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  canSubmit = true,
  message,
  onSubmit,
  onRequestClose,
  marginAmount,
}) => {
  return (
    <Modal
      maxWidth={600}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Confirmation"
      margin={marginAmount}
    >
      <ModalHeader onRequestClose={onRequestClose}>Confirmation</ModalHeader>

      <ModalBody>{message}</ModalBody>

      <ModalFooter>
        <div className="actions">
          <NucleusButton secondary onClick={onRequestClose}>
            Cancel
          </NucleusButton>
          <NucleusButton
            disabled={!canSubmit}
            onClick={onSubmit}
            style={{
              color: 'white',
              background: theme.colors.primary1,
              marginLeft: 12,
            }}
          >
            Confirm
          </NucleusButton>
        </div>
      </ModalFooter>

      <style jsx>{`
        .actions {
          display: flex;
          justify-content: flex-end;
        }
      `}</style>
    </Modal>
  );
};

export default ConfirmationModal;
